import { render, staticRenderFns } from "./commonList.vue?vue&type=template&id=46e6137a"
import script from "./commonList.vue?vue&type=script&lang=js"
export * from "./commonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports